import { render, staticRenderFns } from "./SpecialApprovedInvoicesIndex.vue?vue&type=template&id=31c9e640&"
import script from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
export * from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
import style0 from "./SpecialApprovedInvoicesIndex.vue?vue&type=style&index=0&id=31c9e640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports